import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import { getTemplatesThunk } from './thunk'

const initialState = {
  loading: {
    template: false,
    templateSearch: false,
  },
  templates: [],
  templateIds: [],
  totalRecord: 0,
  panelById: {},
  panelId: [],
}

const name = 'dynamicReport'

const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get template
    builder.addCase(getTemplatesThunk.pending, (state) => {
      state.loading.template = true
    })
    builder.addCase(getTemplatesThunk.fulfilled, (state, action) => {
      state.templates = action.payload.data
      state.totalRecord = action.payload.totalRecords
      state.templateIds = action.payload.metaData || []
      state.loading.template = false
    })
    builder.addCase(getTemplatesThunk.rejected, (state, action) => {
      state.loading.template = action.payload
    })
  },
})

export const selectLoading = (type) => (state) =>
  state[slice.name].loading[type]

export const selectTemplates = (state) => state[slice.name].templates

export const selectTotalRecord = (state) => state[slice.name].totalRecord

export const selectPanelId = (state) => state[slice.name].panelId

export const selectPanelById = (state) => state[slice.name].panelById

export const selectTemplateIds = (state) => state[slice.name].templateIds

export const selectDetailPanel = (id) => (state) =>
  state[slice.name].panelById[id]

register(slice.name, slice.reducer)
